<template>
  <div class="deviceTotal" style="height: 100%;">
    <!--设备总量-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span style="">{{ labelName }}</span>
    </div>
    <el-row style="padding-top: 20px;">
      <el-col :span="18" :offset="3">
        <div style="width: 100%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 5px;margin-top: 8px;">
          <span
            style="width: 5px;height: 5px;background-color: rgba(0, 195, 211, 1);display: inline-block;border-radius: 50%;margin-right: 5px;margin-bottom: 3px;"></span>
          <span>机柜个数：<span id="deviceCount">{{ cabinetCount }}</span></span>
        </div>
        <div style="width: 100%;border-bottom: 1px solid rgba(41, 159, 251, .2);padding-bottom: 5px;margin-top: 10px;">
          <span
            style="width: 5px;height: 5px;background-color: rgba(249, 84, 83, 1);display: inline-block;border-radius: 50%;margin-right: 5px;margin-bottom: 3px;"></span>
          <span>配电柜个数：<span id="deviceAlarm">{{ electricityCount }}</span></span>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import {getCabinetCount, getDetailCabinetCount} from "@/network/device-info";

export default {
  name: "CabinetDeviceTotal",
  props: {
    labelName: {
      type: String,
      default: ""
    },
    spaceId: {
      type: String,
      default: () => null
    },
    tagId: {
      type: String,
      default: null,
    }
  },
  watch: {
    spaceId() {
      this.getData();
    },
    tagId() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      normal: 0,
      exception: 0,
      cabinetCount: 0,
      electricityCount: 0
    }
  },
  methods: {
    getData() {
      getCabinetCount(this.spaceId).then(res => {
        if (res.code === 0) {
          this.cabinetCount = res.data.length
        }
      })
      getDetailCabinetCount(this.spaceId, this.tagId).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if ("精密配电柜" === item.name) {
              this.electricityCount = item.value
            }
          })

        }
      })
    }
  }
}
</script>

<style scoped>
.el-progress >>> .el-progress__text {
  font-size: 1.6rem !important;
  color: #fff;
}
</style>
